import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";
import { FileRepository } from "../../shared/domain/FileRepository";
import { v4 as uuidv4 } from 'uuid';

export class DeliverAndCreateChargeForServiceTransfer {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly file_repo: FileRepository,
  ) {}

  async run(service_ids, org_id, payment_file,promotional_code, num_credits_custom, user_contract, user_contract_facturae): Promise<{ [key: string]: string; }> {    
    let payment_file_path = await this.file_repo.uploadFile(payment_file)
    const uuid = uuidv4()
    let args = {
      service_ids:service_ids, 
      organization_id:org_id, 
      charge_id:uuid, 
      payment_file_path:payment_file_path,
    }
    if (user_contract) {
      args['user_id_to_deliver'] = user_contract;
    }
    if (user_contract_facturae) {
      args['user_id_to_charge'] = user_contract_facturae
    }
    if(promotional_code){
      args['promotional_code'] = promotional_code
    }
    if (num_credits_custom){
      args['num_credits_custom'] = num_credits_custom
    }
    return await this.dispatcher.dispatch('revenue.service_charge.deliver_and_create.transfer', args)
  }
}